import { Link } from "react-router-dom";
const courses = [

  {
    icon: "☕",
    title: "Java Full Stack",
    path:"/training/javafullstack",
    topics:
      "Core Java • Spring Boot • Hibernate • React.js • MySQL • REST API  • MySQL"
  },

  {
    icon: "⚛️",
    title: "MERN Stack",
    path:"/training/mern",
    topics:
      "MongoDB • Express.js • React.js • Node.js • REST API"
  },

  {
    icon: "🐍",
    title: "Python Development",
    path:"/training/pythondevelopment",
    topics:
      "Python • OOP • Django • Flask • REST API • Database"
  },

  {
    icon: "⚙️",
    title: "PLC Programming",
    topics:
      "PLC Basics • Siemens PLC • Ladder Logic • Troubleshooting"
  },

  {
    icon: "🖥️",
    title: "SCADA",
    topics:
      "SCADA • HMI • Tags • Alarms • Trends • PLC Communication"
  },

 

];

function Training() {
 
  return (

    <section id="training" className="section training">

      <div className="section-title">

        <p>LEARN WITH US</p>

        <h2>Professional Training</h2>

        <span>
          Practical training designed for students,
          professionals and corporate teams.
        </span>

      </div>

      <div className="course-grid">

        {courses.map((course, index) => (

          <div className="course-card" key={index}>

            <div className="course-icon">
              {course.icon}
            </div>

            <h3>{course.title}</h3>

            <p>{course.topics}</p><br/>
           <Link
              to={course.path}
              className="syllabus-btn"
            >
              View Syllabus →
            </Link>

          </div>

        ))}

      </div>

    </section>

  );
}

export default Training;